var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
import { NotificationService } from '@/services/NotificationService';
import { verifyTotvsTokens } from '@/clients/crm';
let ToTvsConfigCard = class ToTvsConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.accessToken = '';
        this.integrationToken = '';
        this.ocultedIntegrationToken = true;
        this.ocultedUserToken = true;
        this.tokenVerified = false;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/totvs-logo.png';
        this.companyFields = [
            'Nome/Razão Social',
            'Apelido/Nome Fantasia',
            'CNPJ',
            'Endereço',
            'Data de Nascimento/Data de Fundação',
            'Todos os Emails',
            'Todos os Telefones',
            'Facebook',
            'Website',
            'Outras Informações/Observações',
        ];
        this.decisorFields = [
            'Nome',
            'Empresa',
            'Posição',
            'E-mail',
            'Endereço',
            'Departamento',
            'Nível de decisão',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Todos os planos pagos.',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Usuário que tenha permissão de integração.',
            },
            {
                question: 'Onde ficam os dados das empresas?',
                answer: 'No menu lateral esquerdo vai em Contas e depois em Leads.',
            },
            {
                question: 'Onde ficam os dados dos decisores?',
                answer: 'No menu lateral esquerdo vai em Contas e depois em Contatos.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador oferece a opção de atualizar ou duplicar a empresa no crm',
            },
        ];
        this.tutorialVideoLink = 'https://share.vidyard.com/watch/r6F6JpMi9o82b2CrgL7iKy';
    }
    changedOpenModal() {
        this.ocultedUserToken = true;
        this.ocultedIntegrationToken = true;
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyTotvsTokens({
                accessToken: this.accessToken,
                integrationToken: this.integrationToken,
            });
            this.tokenVerified = true;
            this.ocultedUserToken = true;
            this.ocultedIntegrationToken = true;
            NotificationService.success('Sucesso', 'Seu token foi salvo com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    changeToken() {
        this.accessToken = '';
        this.integrationToken = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], ToTvsConfigCard.prototype, "changedOpenModal", null);
ToTvsConfigCard = __decorate([
    Component({
        name: 'ToTvsConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], ToTvsConfigCard);
export default ToTvsConfigCard;
